"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markings = void 0;
var React = require("react");
var state_1 = require("../compare/state");
var Markings = function () {
    var state = (0, state_1.useStateValue)().state;
    var products = state.products;
    var getMarkingImage = function (product) {
        if (!product.markings || !product.markings.length)
            return React.createElement("p", null, "ingen tilh\u00F8rende markeringer");
        var markingImage = product.markings.map(function (m) {
            return React.createElement("img", { src: "/img/product/marking/".concat(m.markingCode, ".png"), alt: m.markingName, className: "image-marking", key: m.markingCode });
        });
        console.log(markingImage);
        return markingImage;
    };
    var getMarkings = function (products) {
        var marking = products.map(function (product, index) {
            return React.createElement("div", { className: "compare-product-content".concat(index === 0 ? '-first' : ''), key: product.arident },
                React.createElement("section", { className: "ingredients" },
                    React.createElement("h2", { className: "top hidden-xs" }, "Merking"),
                    React.createElement("div", { className: 'marking-image-container' }, getMarkingImage(product))));
        });
        return marking;
    };
    return (React.createElement("div", { className: "row ingredient-section" },
        React.createElement("h2", { className: "top visible-xs" }, "Merking"),
        React.createElement("div", { className: "ingredient-container" }, getMarkings(products))));
    return null;
};
exports.Markings = Markings;
